import { Component, inject } from "@angular/core";
import { CoreModalFooter, CoreModalWindow, MODAL_REF, ModalRef } from "@svs/angular";
import { FeedbackChipsComponent } from "../feedback-chips/feedback-chips.component";

@Component({
  selector: "app-feedback-modal",
  imports: [
    CoreModalWindow,
    CoreModalFooter,
    FeedbackChipsComponent,
  ],
  templateUrl: "./feedback-modal.component.html",
  styleUrl: "./feedback-modal.component.scss",
})
export class FeedbackModalComponent {
  // @ts-ignore
  readonly modalRef: ModalRef = inject(MODAL_REF);
  selected: string[] = [];
}
